(function () {
  const STORAGE_KEY = 'eb:compare';
  const LIMIT = 4;
  let compareTrayActivated = false;

  function readCompare() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function saveCompare(items) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(-LIMIT)));
    window.dispatchEvent(new CustomEvent('eb:compare', { detail: { items: items.slice(-LIMIT) } }));
  }

  function cardData(card) {
    return {
      id: card.dataset.productId,
      handle: card.dataset.productHandle,
      title: card.dataset.productTitle,
      url: card.dataset.productUrl,
      image: card.dataset.productImage,
    };
  }

  function syncCompare(root = document, options = {}) {
    const items = readCompare();
    const ids = new Set(items.map((item) => String(item.id)));
    root.querySelectorAll('[data-eb-compare-card]').forEach((card) => {
      const selected = compareTrayActivated && ids.has(String(card.dataset.productId));
      card.classList.toggle('is-compared', selected);
      card.querySelector('[data-eb-compare-toggle]')?.setAttribute('aria-pressed', String(selected));
    });
    renderGlobalTray(items, options);
  }

  function handleFromUrl(url) {
    const match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function compareUrl(page, items) {
    const handles = items.map((item) => item.handle || handleFromUrl(item.url) || item.id).filter(Boolean);
    const url = new URL(page, window.location.origin);
    if (handles.length) url.searchParams.set('products', handles.join(','));
    return url.toString();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[char]);
  }

  function renderGlobalTray(items = readCompare(), options = {}) {
    const tray = document.querySelector('[data-eb-card-compare-tray]');
    if (!tray) return;

    if (options.activate) compareTrayActivated = true;
    const hasItems = compareTrayActivated && items.length > 0;
    tray.hidden = !hasItems;
    tray.classList.toggle('is-visible', hasItems);

    const thumbs = tray.querySelector('[data-eb-card-compare-thumbs]');
    if (thumbs) {
      thumbs.innerHTML = items.map((item) => `
        <button type="button" data-eb-card-compare-remove="${escapeHtml(item.id)}" aria-label="${escapeHtml(item.title)}">
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : '<span></span>'}
        </button>
      `).join('');
    }

    const link = tray.querySelector('[data-eb-card-compare-link]');
    if (link) {
      const label = (tray.dataset.labelTemplate || 'Compare (__COUNT__)').replace('__COUNT__', items.length);
      link.href = compareUrl(tray.dataset.comparePage || '/pages/compare', items);
      link.setAttribute('aria-label', label);
      const count = link.querySelector('[data-eb-card-compare-count]');
      if (count) count.textContent = items.length;
    }
  }

  function toggleCompare(card) {
    const item = cardData(card);
    if (!item.id) return;
    const items = compareTrayActivated ? readCompare() : [];
    const existing = items.findIndex((entry) => String(entry.id) === String(item.id));
    if (existing >= 0) items.splice(existing, 1);
    else {
      if (items.length >= LIMIT) items.shift();
      items.push(item);
    }
    saveCompare(items);
    syncCompare(document, { activate: true });
  }

  function applySwatch(swatch) {
    const card = swatch.closest('.eb-product-card');
    if (!card) return;
    const imageUrl = swatch.dataset.swatchImage;
    const variantUrl = swatch.dataset.variantUrl;
    if (imageUrl) {
      const image = card.querySelector('.eb-product-card__image');
      if (image) {
        image.removeAttribute('srcset');
        image.src = imageUrl;
      }
    }
    if (variantUrl) {
      card.querySelectorAll('.eb-product-card__media, .eb-product-card__link, .eb-product-card__cta').forEach((link) => {
        link.href = variantUrl;
      });
    }
    card.querySelectorAll('[data-eb-swatch]').forEach((button) => button.classList.toggle('is-active', button === swatch));
  }

  document.addEventListener('mouseover', (event) => {
    const swatch = event.target.closest('[data-eb-swatch]');
    if (swatch) applySwatch(swatch);
  });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-eb-swatch]');
    if (swatch) {
      event.preventDefault();
      applySwatch(swatch);
      return;
    }

    const toggle = event.target.closest('.eb-product-card [data-eb-compare-toggle]');
    if (toggle) {
      event.preventDefault();
      const card = toggle.closest('[data-eb-compare-card]');
      if (card) toggleCompare(card);
      return;
    }

    const remove = event.target.closest('[data-eb-card-compare-remove]');
    if (remove) {
      event.preventDefault();
      const items = readCompare().filter((item) => String(item.id) !== String(remove.dataset.ebCardCompareRemove));
      saveCompare(items);
      syncCompare(document, { activate: true });
      return;
    }

    if (event.target.closest('[data-eb-card-compare-clear]')) {
      event.preventDefault();
      saveCompare([]);
      compareTrayActivated = false;
      syncCompare();
    }
  });

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) syncCompare();
  });
  window.addEventListener('eb:product-cards:updated', (event) => {
    syncCompare(event.detail?.root || document);
  });

  document.addEventListener('DOMContentLoaded', () => syncCompare());
  syncCompare();
})();
